import React from 'react';
import { Avatar } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useBetterAuth } from 'context/BetterAuthProvider';
import Logo from 'assets/logo_icon_only.svg';

const AppLogo = () => {
  const { isAuthenticated } = useBetterAuth();
  const to = isAuthenticated ? '/' : '/login';
  return (
    <Link to={to}>
      <Avatar src={Logo} alt="logo" />
    </Link>
  );
};

export default AppLogo;
